import React, {Component} from 'react';
import {Modal,Form,FormGroup,FormControl,ControlLabel,ButtonToolbar,Button} from 'react-bootstrap'
import AutopartStore from '../../stores/AutopartStore'

class AutoPartNewItemPopup extends Component {
  constructor(...args){
    super(...args)
    this.state = this.initState()
  }

  initState(){
    return {description:'',descriptionEn:'',errorText:''}
  }

    onHide(){
      this.setState(this.initState())
      this.props.onHide();
    }

    onTextChange(e){
      this.setState({description:e.target.value})
    }

    onTextEnChange(e){
      this.setState({descriptionEn:e.target.value})
    }

    onSaveClick(){
      let that = this
      let {description,descriptionEn} = this.state
      let {carType,subCatId,subCatPos} = this.props
      let postData = {description:description,description_en:descriptionEn,car_type:carType,sub_cat_id:subCatId,sub_cat_pos:subCatPos}
      if(description!=='' && descriptionEn!==''){
        AutopartStore.saveItem(postData,function(result){

          that.props.onSave(result.data);
          that.onHide()
        },function(){

        })
      }else{
        this.setState({errorText:'* The description was empty.'})
      }
    }

    render(){
      let {description,descriptionEn,errorText} = this.state

      let label  = 'New Auto Part Item'
      return (
        <Modal show={this.props.show} enforceFocus={false} onHide={this.onHide.bind(this)} dialogClassName="fullwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>{label}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='row'>
              <div className='col-md-12'>
                <div className="form-group">
                  <FormGroup controlId="auto-part-item">
                    <ControlLabel>Description (Thai) :</ControlLabel>
                    {' '}
                    <FormControl  type="text" value={description}
                      onChange={this.onTextChange.bind(this)}/>
                  </FormGroup>
                </div>
                <div className="form-group">
                  <FormGroup controlId="auto-part-item">
                    <ControlLabel>Description (English) :</ControlLabel>
                    {' '}
                    <FormControl  type="text" value={descriptionEn}
                      onChange={this.onTextEnChange.bind(this)}/>
                  </FormGroup>
                </div>
            </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className='pull-left'>{errorText}</div>
            <ButtonToolbar  className='form-group' style={{display:'inline-block',marginLeft:'20px'}}>
              <Button bsStyle='success' style={{width:'80px'}} onClick={this.onSaveClick.bind(this)}>Save</Button>
              <Button bsStyle='default' style={{width:'80px'}} onClick={this.onHide.bind(this)}>Cancel</Button>
            </ButtonToolbar>
          </Modal.Footer>
       </Modal>
      )
    }
}

export default AutoPartNewItemPopup



// WEBPACK FOOTER //
// ./src/view/autoparts/AutoPartNewItemPopup.js